import { render, staticRenderFns } from "./DashboardActionItem.vue?vue&type=template&id=38965d67&scoped=true"
import script from "./DashboardActionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardActionItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardActionItem.vue?vue&type=style&index=0&id=38965d67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38965d67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38965d67')) {
      api.createRecord('38965d67', component.options)
    } else {
      api.reload('38965d67', component.options)
    }
    module.hot.accept("./DashboardActionItem.vue?vue&type=template&id=38965d67&scoped=true", function () {
      api.rerender('38965d67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/DashboardWidgets/actions/DashboardActionItem.vue"
export default component.exports